var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C6.71207 13 5.93185 12.8448 5.2039 12.5433C4.47595 12.2417 3.81451 11.7998 3.25736 11.2426C2.70021 10.6855 2.25825 10.0241 1.95672 9.2961C1.65519 8.56815 1.5 7.78793 1.5 7C1.5 6.21207 1.65519 5.43185 1.95672 4.7039C2.25825 3.97595 2.70021 3.31451 3.25736 2.75736C3.81451 2.20021 4.47595 1.75825 5.2039 1.45672C5.93185 1.15519 6.71207 1 7.5 1C8.28793 1 9.06815 1.15519 9.7961 1.45672C10.5241 1.75825 11.1855 2.20021 11.7426 2.75736C12.2998 3.31451 12.7417 3.97595 13.0433 4.7039C13.3448 5.43185 13.5 6.21207 13.5 7C13.5 7.78793 13.3448 8.56815 13.0433 9.2961C12.7417 10.0241 12.2998 10.6855 11.7426 11.2426C11.1855 11.7998 10.5241 12.2417 9.7961 12.5433C9.06815 12.8448 8.28793 13 7.5 13L7.5 13Z",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5L9.5 9",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5L5.5 9",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c964bd59df0a36de66264e854831491e.svg";
export { ForwardRef as ReactComponent };